import { useEffect } from 'react';
import { Tab } from 'semantic-ui-react';
import styled from 'styled-components';
import ConsecutiveFailures from './ConsecutiveFailures';

const Container = styled.div`
	margin: 15px 0 0 -10px;
`;

function Reports() {
	useEffect(() => {
		console.log(`useEffect`)
	}, []);

	const panes = [
		{
			menuItem : `Consecutive Failures`,
			render   : () => <ConsecutiveFailures />
		},
		/*
		{
			menuItem : `Flaky last 24 hours`,
			render   : () => {}
		},
		{
			menuItem : `High Failures`,
			render   : () => {

			}
		},
		{
			menuItem : `High Retires`,
			render   : () => {

			}
		},
		*/
	]

	return (
		<Container>
			<Tab menu={{ secondary : true, fluid : true, vertical : true, tabular : true }} panes={panes} />
		</Container>
	)
}

export default Reports;
